export type MessageKind = "notify" | "traceback" | "system" | "echo";

export interface DisplayMessage {
    id: string;
    kind: MessageKind;
    html: string;
    timestamp: number;
}

const MAX_MESSAGES = 2000;

class MessageStore {
    entries = $state<DisplayMessage[]>([]);

    push(msg: DisplayMessage) {
        this.entries.push(msg);
        if (this.entries.length > MAX_MESSAGES) {
            this.entries = this.entries.slice(-MAX_MESSAGES);
        }
    }

    clear() {
        this.entries = [];
    }
}

export const messages = new MessageStore();
